"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const features_1 = require("../../features");
const eventBus_1 = require("../../eventBus");
(0, eventBus_1.initGlobalEventBus)();
const configureFramework = (Session, domain, bankId, language, additionalPlugins = []) => {
    //TODO Session needs XHR Authplugin and this plugin needs session
    const plugins = [...additionalPlugins, new features_1.XHRAcceptLanguagePlugin(language), new features_1.XHRBankIdPlugin(bankId)];
    Session.setXHR(new features_1.XHR({
        plugins,
    }));
    const AuthApi = new features_1.XHR({
        plugins: [...additionalPlugins],
    });
    const Authenticator = null; //TODO Quitar null cuando se refactorize a interfaces
    return {
        Authenticator,
    };
};
exports.configureFramework = configureFramework;
//# sourceMappingURL=base.js.map